define([
  'underscore',
  'es6!sumo/util',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/clicktrigger',
], (_, Util, ClickTrigger) => {

  class ClickTriggers {
    constructor(service) {
      this.service = service;
      this.triggers = {};

      this.onClickTriggerClick = this.onClickTriggerClick.bind(this);
    }

    prepClassNameClickTriggers() {
      const triggers = document.body.querySelectorAll('[class*=sumome-listbuilder-id-]');
      if (!triggers || !triggers.length) return;

      for (let i = 0; i < triggers.length; i++) {
        const el = triggers[i];
        const className = el.className;
        const index = className.indexOf('sumome-listbuilder-id-');
        const triggerId = className.substr(index + 22, index + 58);
        el.setAttribute('data-sumome-listbuilder-id', triggerId);
      }
    }

    bindClickTriggers(options) {
      this.prepClassNameClickTriggers();
      const triggerEls = document.body.querySelectorAll('[data-sumome-listbuilder-id]:not([data-sumome-trigger])');

      if (triggerEls.length === 0) return;

      console.log('Binding ListBuilder click triggers');
      const triggerIds = [];
      for (let i = 0; i < triggerEls.length; i++) {
        const triggerEl = triggerEls[i];
        const triggerId = triggerEl.getAttribute('data-sumome-listbuilder-id');

        triggerEl.setAttribute('data-sumome-trigger', true);
        triggerIds.push(triggerId);
        Util.addEvent(triggerEl, 'click', this.onClickTriggerClick);

        // Set href on trigger if none exists
        if (triggerEl.nodeName === 'A' && !triggerEl.getAttribute('href')) triggerEl.href = 'javascript:void(0);';
      }

      const postData = _.extend({ trigger_ids: triggerIds }, options, {
        listBuilder3Service: false,
        listBuilder3ClickTriggers: true,
      });
      this.service.post('/services', postData).then(res => (
        this.onLoadClickTriggers(res.data.listBuilder3ClickTriggers)
      ));
    }

    onLoadClickTriggers(data) {
      if (data.success !== true) return;

      _.each(data.triggers, (trigger, triggerId) => {
        // patch subscribe_redirect_url with <a href=""> if applicable
        if (!trigger.subscribe_redirect_url) {
          const el = document.body.querySelector(`[data-sumome-listbuilder-id="${triggerId}"]`);

          if (el) {
            const href = el.getAttribute('href');

            if (href) {
              trigger.subscribe_redirect_url = href;
            }
          }
        }

        // patch subscribe_redirect_target with <a target=""> if applicable
        if (!trigger.subscribe_redirect_target) {
          const el = document.body.querySelector(`[data-sumome-listbuilder-id="${triggerId}"]`);

          if (el) {
            const target = el.getAttribute('target');

            if (target && target == '_blank') {
              trigger.subscribe_redirect_target = 'new';
            }
          }
        }

        // All click triggers are normal mode popups
        trigger.display_mode = 'normal';
        trigger.triggerId = triggerId;
        this.triggers[triggerId] = new ClickTrigger(this.service, trigger);
        if (trigger.goal === 'custom') {
          trigger.id = trigger.trigger_id;
        }
      });
    }

    onClickTriggerClick(e) {
      e.preventDefault();

      const triggerId = this.findTriggerId(e);

      if (!this.triggerExists(triggerId)) {
        console.log(`Error: Clicked non-existant trigger ${triggerId}`);
        return;
      }

      const trigger = this.getTrigger(triggerId);

      trigger.onClick(e.target);
    }

    findTriggerId(e) {
      let el = e.target;
      let triggerId = el.getAttribute('data-sumome-listbuilder-id');

      while (!triggerId && el && el.parentNode && el !== document.body) {
        el = el.parentNode;
        triggerId = el.getAttribute('data-sumome-listbuilder-id');
      }

      return triggerId;
    }

    triggerExists(triggerId) {
      return (this.triggers.hasOwnProperty(triggerId) && triggerId in this.triggers);
    }

    getTrigger(triggerId) {
      if (!this.triggerExists(triggerId)) return false;

      return this.triggers[triggerId];
    }
  }

  return ClickTriggers;
});
